import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from '@mandae/ng-popover';
import { PopoverDirective } from './popover.directive';

@NgModule({
  declarations: [
    PopoverDirective,
  ],
  exports: [
    PopoverDirective,
  ],
  imports: [
    CommonModule,
    PopoverModule,
  ],
})
export class SharedModule { }
